/** PURE_IMPORTS_START ._AsyncScheduler PURE_IMPORTS_END */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b)
        if (b.hasOwnProperty(p))
            d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
import { AsyncScheduler } from './AsyncScheduler';
export var QueueScheduler = /*@__PURE__*/ (/*@__PURE__*/ function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler));
//# sourceMappingURL=QueueScheduler.js.map



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/node_modules/rxjs/_esm5/scheduler/QueueScheduler.js.pre-build-optimizer.js